/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipoPraticaOperatoreAssegnazioneItem } from './tipo-pratica-operatore-assegnazione-item';


export interface TipoPraticaOperatoriBulkReplaceForm { 
    version: number;
    assegnazioni: Array<TipoPraticaOperatoreAssegnazioneItem>;
}

